/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const TransitionContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const LineContainer = styled.div({
  paddingBottom: `${gridSize()}px`,
});

export const WarningContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const SelectContainer = styled.div({
  paddingRight: `${gridSize() / 4}px`,
  paddingLeft: `${gridSize() / 4}px`,
  flexShrink: 0,
});

export const IssueContainer = styled.div({
  paddingLeft: `${gridSize() / 4}px`,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
});

export const IssueKeyContainer = styled.div({
  color: token('color.text.subtlest'),
  paddingLeft: `${gridSize()}px`,
  paddingRight: `${gridSize()}px`,
  maxWidth: `${gridSize() * 14}px`,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const IssueSummaryContainer = styled.div({
  maxWidth: `${gridSize() * 29}px`,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const ArrowContainer = styled.div({
  display: 'flex',
  paddingLeft: `${gridSize() * 1.5}px`,
  paddingRight: `${gridSize() / 2}px`,
});

export const TriggerContainer = styled.div({
  marginLeft: `${gridSize() / 2}px`,
  marginBottom: `${gridSize() / 8}px`,
});
